import _objectSpread from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, commonData } from "@/mixins/index";
import updateStudentInfo from "./component/updateStudentInfo.vue";
import capacityManage from "./component/capacityManage.vue";
import unseal from './component/unseal.vue';
import studentcomment from './component/studentcomment.vue';
import disciplineList from './component/disciplineList.vue';
export default {
  name: "trainmanage",
  components: {
    unseal: unseal,
    updateStudentInfo: updateStudentInfo,
    capacityManage: capacityManage,
    studentcomment: studentcomment,
    disciplineList: disciplineList
  },
  mixins: [loadMoreList, commonData],
  props: ['teamId'],
  data: function data() {
    return {
      tableData: [],
      total: 0
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var page;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
                _this.paramsData.page = page;

                _this.$api.getStudentsList(_objectSpread(_objectSpread({}, _this.paramsData), {}, {
                  team_id: _this.teamId
                })).then(function (res) {
                  if (res.code == 200) {
                    _this.tableData = res.data.data;
                    _this.total = res.data.total;
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    passClick: function passClick(id) {
      var _this2 = this;

      this.$api.review({
        id: id,
        approved: true
      }).then(function (res) {
        if (res.code == 200) {
          _this2.$message.success('操作成功');

          _this2.getList(_this2.paramsData.page);
        } else {
          _this2.$message.error(res.msg);
        }
      });
    }
  }
};